<template>
  <!-- <div class="maximum-box"> -->
  <div class="main" v-loading="loading">
    <!-- <div class="header">
      入库单号: {{ uploadData.key }}
    </div> -->
    <div class="wrapper">
      <div class="card">
        <div class="info-box">
          <div class="img-box"><img :src="skuInfo.skuImage" alt="" /></div>
          <div class="right-info">
            <div>{{ skuInfo.skuName }}</div>
            <div class="describe-text"><span>sku：</span>{{ skuInfo.sku }}</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="subject-box">
          <div
            class="image-item"
            v-for="(item, index) in fileList"
            :key="item.imageUrl"
          >
            <!-- <img :src="item" alt="" @click="handlePreview(item)"> -->
            <el-image
              style="width: 96px; height: 96px"
              :src="item.imageUrl"
              :preview-src-list="previewImages"
            >
            </el-image>
            <div class="close">
              <i class="el-icon-close" @click="handleDelete(item, index)"></i>
            </div>
          </div>
          <el-upload
            :action="action"
            multiple
            :before-upload="beforeUpload"
            :headers="headers"
            :data="uploadData"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            accept="image/*"
            :show-file-list="false"
            class="upload-image"
          >
            <i slot="default" class="el-icon-plus" />
          </el-upload>
        </div>
      </div>
      <el-button class="submitQCImg" type="primary" @click="handleSubmit"
        >提交六面图</el-button
      >
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import {
  getCheckSixImg,
  deleteSixImg,
  saveSixImg,
} from "../api/PutInStorageOrder";
// const domain = process.env.NODE_ENV === "development" ? '/apis' : process.env.VUE_APP_FBA_API
export default {
  data() {
    return {
      //action: `http://test.wms.java.api.nantang-tech.com/multipartFile/upload/`,
      //action: `http://test.wms.java.api.nantang-tech.com/warehouse/stock/sku/image/upload`,
      action: `http://wms.java.nantang-tech.com/warehouse/stock/sku/image/upload`,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      loading: false,
      uploadData: {},
      ticketCode: "",
      skuInfo: {
        skuImage: "",
        sku: "",
        skuName: "",
      },
      headers: {
        authorization: "",
        staffId: "",
        staffName: "",
      },
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    previewImages() {
      return this.fileList.map((item) => item.imageUrl);
    },
  },
  methods: {
    handleCloses() {
      this.$emit("close");
    },
    handlePreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    async refreshImg() {
      if (!this.uploadData.sku) return;
      this.loading = true;
      const { data } = await getCheckSixImg(this.uploadData);
      this.fileList = data.map((item) => ({
        id: item.id,
        imageName: item.imageName,
        imageUrl: item.imageUrl,
        sku: item.sku,
        // whouseId: item.whouseId
      }));
      this.loading = false;
    },
    async handleDelete(item, index) {
      const { sku, imageName } = item;
      await deleteSixImg({ sku, imageName });
      this.fileList.splice(index, 1);
    },
    getParmeter(variable) {
      if (window.location.href.split("?")[1].length) {
        let query = window.location.href.split("?")[1]; // 这里query的结果是：   promotion_code=ZB06AKXFSR&sku=100
        let vars = query.split("&"); // 这里vars的结果是：   ["promotion_code=ZB06AKXFSR", "sku=100"]
        for (let i = 0; i < vars.length; i++) {
          //然后循环
          let pair = vars[i].split("="); //  循环第一次结果pair ["promotion_code", "ZB06AKXFSR"]  循环第二次结果pair ["sku", "100"]
          if (pair[0] === variable) {
            // 做判断 如果参数名和我们的实参一样
            console.log(pair, "pair");
            return pair[1]; // 就返回对应的值
          }
        }
        return "";
      }
    },
    getInfo() {
      this.skuInfo.sku = this.getParmeter("sku");
      this.skuInfo.skuName = decodeURIComponent(this.getParmeter("skuName"));
      this.skuInfo.skuImage = decodeURIComponent(this.getParmeter("skuImage"));
      this.headers.authorization = this.getParmeter("authorization");
      this.headers.staffId = this.getParmeter("staffId");
      this.headers.staffName = this.getParmeter("staffName");
      this.uploadData.sku = this.getParmeter("sku");
      this.uploadData.type = this.getParmeter("type");
      // this.uploadData.whouseId = this.getParmeter('whouseId')
      sessionStorage.setItem("staff-id", this.getParmeter("staffId"));
      sessionStorage.setItem("name", this.getParmeter("staffName"));
    },
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      const isLengthLimit = this.fileList.length < 9;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      if (!isLengthLimit) {
        this.$message.error("上传图片数量不能超过 9 张!");
      }
      const isPass = isJPG && isLt10M && isLengthLimit;
      if (isPass) {
        this.loading = true;
      }
      return isPass;
    },
    handleExceed(files, fileList) {},
    uploadSuccess(response, _, fileList) {
      this.loading = false;
      if (response.code === 0) {
        this.refreshImg();
        return;
      }
      this.$message.error(response.msg);
    },
    uploadError() {
      this.loading = false;
      this.$message.error("上传失败");
    },
    async handleSubmit() {
      if (!this.fileList.length) {
        this.$message.error("请上传图片");
        return;
      }
      if (this.fileList.length > 9) {
        this.$message.error("图片数量不能超过9张");
        return;
      }
      this.loading = true;
      await saveSixImg(this.uploadData);
      this.loading = false;
      this.$router.push("/finish?title=六面图");
    },
  },
  mounted() {
    console.log(process.env, "process.env");
    this.refreshImg();
  },
};
</script>
<style scoped lang="less">
.main {
  height: 100vh;
  width: 100vw;
  background: #dbe8ff;

  .wrapper {
    padding: 16px;
  }

  .header {
    height: 48px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-weight: 600;
    font-size: 18px;
  }

  .content {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;

    .subject-box {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .image-item {
        width: 96px;
        height: 96px;
        position: relative;

        .close {
          position: absolute;
          top: -12px;
          right: -12px;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #2c3e50;
          border-radius: 50%;
          cursor: pointer;
          color: #fff;

          i {
            font-size: 18px;
          }
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }
    }
  }

  .card {
    padding: 16px;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 20px;
  }
}
</style>
<style lang="less">
.upload-image {
  .el-upload {
    width: 96px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #ccc;
    border-radius: 6px;

    .el-upload-dragger {
      width: 100%;
      height: 100%;
    }

    .el-icon-plus {
      font-size: 24px;
      color: #ccc;
    }
  }
}

.submitQCImg {
  width: 100%;
}

.info-box {
  display: flex;

  .img-box {
    width: 96px;
    margin-right: 16px;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }

  .right-info {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
